/* LINUX — two-sided artwork, exact size variants and native page scrolling. */
(function () {
  'use strict';
  const L = window.LINUX;
  const root = document.querySelector('[data-customize]');
  if (!root || !root.querySelector('[data-cz-form]')) return;
  const meta = JSON.parse(root.querySelector('[data-product-json]')?.textContent || '{}');
  const catalog = JSON.parse(root.querySelector('[data-cz-catalog]')?.textContent || '{}');
  const mapping = JSON.parse(root.querySelector('[data-cz-config]')?.textContent || '{}');
  const model = L.customizeModel;
  const strings = { ...meta.strings, ...JSON.parse(root.querySelector('[data-cz-strings]')?.textContent || '{}') };
  const MAX = Number(root.dataset.maxMb || 10) * 1024 * 1024;
  const MIN_EMB = Number(root.dataset.minEmbroidery || 10);
  const MAX_QTY = Number(root.dataset.maxQty || 50);
  const SEG_ALIAS = { individual: 'individual', 'أفراد': 'individual', 'افراد': 'individual', university: 'university', 'جامعات': 'university', 'طلبة': 'university', company: 'company', 'شركات': 'company' };
  const segCfg = typeof mapping.segments === 'string' ? mapping.segments.split(/\r?\n|;/).reduce((acc, line) => {
    const m = line.match(/^\s*([^\d\s:=٠-٩]+)\s*[:=]\s*(.*)$/);
    if (m && SEG_ALIAS[m[1].trim().toLowerCase()]) acc[SEG_ALIAS[m[1].trim().toLowerCase()]] = m[2];
    return acc;
  }, {}) : null;
  const tiersFor = (seg) => model.tiersFrom(segCfg ? model.parseTiers(segCfg[seg] ?? mapping.segments) : mapping.tiers).filter((tier) => tier.quantity <= MAX_QTY);
  let tiers = tiersFor('individual');
  const MATRIX_AT = 7;
  const AREA = meta.area || {};
  const SCALE_MIN = 10, SCALE_MAX = 90;
  const PRINT_CM = mapping.print || {};
  const SHOW_QUALITY = mapping.quality !== false;
  const PLACE_EN = { center: 'Center chest', pocket: 'Left chest', right: 'Right chest', upper: 'Upper back', middle: 'Center back' };
  let syncTextLabel = () => {};
  const SIDES = ['front', 'back'];

  const q = (s) => root.querySelector(s);
  const qa = (s) => Array.from(root.querySelectorAll(s));
  const canvas = q('[data-cz-canvas]'), garment = q('[data-cz-garment]');
  const empty = q('[data-cz-pick]'), emptyLabel = q('[data-cz-empty-label]'), err = q('[data-cz-error]');
  const garmentProp = q('[data-cz-garment-prop]'), colorProp = q('[data-cz-color-prop]'), methodProp = q('[data-cz-method-prop]'), sidesProp = q('[data-cz-sides-prop]'), sizesProp = q('[data-cz-sizes-prop]');
  const qtyField = q('[data-cz-qty-field]'), qtyInput = q('[data-cz-qty]'), sizesList = q('[data-cz-sizes-list]'), sizeTpl = q('[data-cz-size-row]');
  const scale = q('[data-cz-scale]'), scaleOut = q('[data-cz-scale-out]'), rotate = q('[data-cz-rotate]'), rotateOut = q('[data-cz-rotate-out]');
  const form = q('[data-cz-form]'), submitErr = q('[data-cz-submit-error]'), total = q('[data-cz-total]'), breakdown = q('[data-cz-breakdown]');
  const minNotice = q('[data-cz-min-notice]'), eta = q('[data-cz-eta]'), idInput = q('[data-variant-id]'), atcPrice = q('[data-atc-price]'), wa = q('[data-cz-wa]');
  const tools = q('[data-cz-tools]'), hint = q('[data-cz-hint]'), area = q('[data-cz-area]'), colorLabel = q('[data-cz-color-label]'), fine = q('[data-cz-fine]'), fineSide = q('[data-cz-fine-side]');
  const firstColor = q('[data-cz-color].is-active') || q('[data-cz-color]');
  const editToggle = q('[data-cz-edit-toggle]');
  const photos = qa('[data-cz-photo]');
  const mocks = qa('[data-cz-mock]');
  const board = q('[data-cz-board]'), orgBox = q('[data-cz-org]'), orgInput = q('[data-cz-org-input]'), orgLabel = q('[data-cz-org-label]'), orgNote = q('[data-cz-org-note]'), segProp = q('[data-cz-seg-prop]');
  const customBox = q('[data-cz-custom-color]'), customInput = q('[data-cz-custom-input]');
  const customName = () => customInput?.value.trim() ? `Custom: ${customInput.value.trim()}` : 'Custom';
  const SEG_EN = { individual: 'Individual', university: 'University / students', company: 'Company' };

  // per-side design state
  const design = {};
  SIDES.forEach((side) => {
    design[side] = { x: 50, y: 42, s: 42, r: 0, has: false, file: null,
      el: q(`[data-cz-design="${side}"]`), img: q(`[data-cz-design="${side}"] img`), input: q(`[data-cz-file="${side}"]`),
      drop: q(`[data-cz-drop="${side}"]`), row: q(`[data-cz-file-row="${side}"]`), pos: q(`[data-cz-pos="${side}"]`), mock: q(`[data-cz-mockup="${side}"]`), dot: q(`[data-cz-side-dot="${side}"]`) };
  });

  const state = {
    side: root.dataset.side || 'back', shape: root.dataset.shape || 'hoodie',
    label: q('[data-cz-garment-opt].is-active')?.dataset.label || 'Hoodie',
    colorKey: firstColor?.dataset.czColor, color: firstColor?.dataset.czColorName || '', colorValue: firstColor?.dataset.czVariantKey || '', hex: firstColor?.dataset.czTone || '#181818',
    segment: 'individual', quoteTotal: 0, method: 'Print', qty: 1, sizes: [], pc: [], mx: false, unit: meta.price || 0, editing: false,
  };
  const cur = () => design[state.side];
  const sideName = (s) => (s === 'back' ? strings.back : strings.front) || s;

  /* ---- Print area per garment/side: [cx, cy, w, h] in % of the stage ---- */
  function printArea(side = state.side) { const a = (AREA[state.shape] || {})[side]; return a || [50, 45, 52, 52]; }
  function paintArea() {
    const [cx, cy, w, h] = printArea();
    area.style.left = cx + '%'; area.style.top = cy + '%'; area.style.width = w + '%'; area.style.height = h + '%';
  }
  function clampPos(d, side) {
    const [cx, cy, w, h] = printArea(side);
    const half = d.s / 2;
    d.x = Math.max(cx - w / 2 + Math.min(half, w / 2) * .35, Math.min(cx + w / 2 - Math.min(half, w / 2) * .35, d.x));
    d.y = Math.max(cy - h / 2 + Math.min(half, h / 2) * .35, Math.min(cy + h / 2 - Math.min(half, h / 2) * .35, d.y));
  }
  function centerInArea(d = cur(), side = state.side) { const [cx, cy] = printArea(side); d.x = cx; d.y = cy; }
  // A new design starts at 80% of its print area (drawn width = s × .66% of the stage).
  const aspectOf = (d) => (d && d.img && d.img.naturalWidth && d.img.naturalHeight ? d.img.naturalWidth / d.img.naturalHeight : 1);
  const clampS = (s) => Math.max(SCALE_MIN, Math.min(SCALE_MAX, s));
  function defaultScale(side = state.side, d = design[side]) { return clampS(model.fitWidth(printArea(side), .8, aspectOf(d)) / .66); }
  function fitScale(side = state.side, d = design[side]) { return clampS(model.fitWidth(printArea(side), 1, aspectOf(d)) / .66); }

  /* ---- Variant / price ---- */
  function pickVariant(size, key) {
    if (String(size).startsWith('custom:')) size = defaultSize();
    const c = key && key !== state.colorKey ? colorInfo(key) : null;
    return model.variantFor(catalog[state.shape], { color: c ? c.value : (state.colorValue || state.color), method: state.method, size }, mapping);
  }
  function colorInfo(key) {
    const b = q(`[data-cz-color="${key}"]`);
    const name = key === 'custom' ? customName() : (b?.dataset.czColorName || '');
    return { name, value: b?.dataset.czVariantKey || name, label: key === 'custom' ? (customInput?.value.trim() || strings.customColor || name) : (b?.getAttribute('aria-label') || name), hex: b?.dataset.czTone || '#888' };
  }
  const selectedVariants = () => state.sizes.slice(0, state.qty).map((s, i) => pickVariant(s, pieceColor(i)));
  const interpolate = (text, values) => Object.entries(values).reduce((result, [key, value]) => result.replaceAll(`[${key}]`, value), text || '');
  let priceSignature = '';

  function paintPricing() {
    const selected = selectedVariants();
    const signature = `${state.segment}|${state.shape}|${state.method}|${state.colorKey}|${state.qty}|${state.sizes.slice(0, state.qty).join(',')}|${state.mx}|${state.pc.join(',')}|${extras().total}`;
    const priced = model.quote(selected, tiers);
    state.quoteTotal = priced?.total || 0;
    idInput.value = selected[0]?.id ? selected[0].id : '';
    q('[data-cz-submit]').disabled = root.dataset.preparing === 'true' || !priced || SIDES.some((side) => design[side].loading);
    q('[data-cz-availability]').hidden = !!priced;
    if (signature === priceSignature) return;
    priceSignature = signature;
    sizesList.querySelectorAll('.cz__size-row').forEach((row, index) => {
      row.classList.toggle('is-unavailable', !selected[index]?.id);
      row.querySelectorAll('input').forEach((input) => {
        input.disabled = !pickVariant(input.value)?.id;
        input.closest('label').classList.toggle('is-disabled', input.disabled);
      });
    });
    const ex = extras();
    const amount = priced ? L.money(priced.total + ex.total * 100) : '—';
    if (total) total.textContent = amount;
    if (atcPrice) { atcPrice.textContent = amount; atcPrice.hidden = !!priced?.estimated; }
    state.unit = priced?.unit || 0;
    q('[data-cz-unit]').textContent = priced ? L.money(priced.unit) : '—';
    q('[data-cz-summary-qty]').textContent = L.digits(state.qty);
    q('[data-cz-unit-label]').textContent = priced?.estimated ? strings.estimated_unit_price : strings.unit_price;
    q('[data-cz-total-label]').textContent = priced?.estimated ? strings.estimated_total : strings.total;
    q('[data-cz-savings-row]').hidden = !priced?.savings;
    q('[data-cz-savings]').textContent = priced ? L.money(priced.savings) : '';
    q('[data-cz-pricing-hint]').textContent = tiers.length || priced?.savings ? strings.pricing_more : strings.pricing_standard;
    q('[data-cz-pricing-note]').hidden = !tiers.length;
    const baseUnit = Number(selected.find((variant) => variant?.id)?.price ?? meta.price ?? 0);
    const unitAt = (discount) => Math.round(baseUnit * (100 - discount) / 100);
    const next = q('[data-cz-next-tier]');
    next.hidden = !priced || (!priced.next && !priced.tier);
    next.textContent = priced?.next ? interpolate(strings.next_unit, { count: L.digits(priced.next.quantity - state.qty), price: L.money(unitAt(priced.next.discount)) }) : (priced?.tier ? strings.best_tier : '');
    const list = q('[data-cz-price-tiers]');
    list.hidden = !tiers.length;
    list.replaceChildren();
    const activeQ = priced?.tier?.quantity || 1;
    [{ quantity: 1, discount: 0 }, ...tiers].forEach((tier) => {
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'cz__price-tier';
      const on = tier.quantity === activeQ;
      button.classList.toggle('is-active', on);
      button.setAttribute('aria-pressed', String(on));
      const label = tier.quantity === 1 ? strings.ladder_one : interpolate(strings.ladder_from, { count: L.digits(tier.quantity) });
      [['span', label], ['strong', L.money(unitAt(tier.discount))], ['em', tier.discount ? interpolate(strings.ladder_off, { percent: L.digits(tier.discount) }) : strings.ladder_base]].forEach(([tag, text]) => {
        const el = document.createElement(tag); el.textContent = text; button.append(el);
      });
      button.addEventListener('click', () => setQty(tier.quantity));
      list.append(button);
    });
    if (breakdown) breakdown.textContent = ex.total ? interpolate(fees().variant ? strings.extras_line : strings.extras_estimate, { price: L.money(ex.total * 100) }) : '';
  }

  /* ---- Photo / mockup layers ---- */
  function photoFor(side = state.side) {
    const want = `${state.colorKey}|${state.shape}-${side}`;
    return photos.find((img) => img.dataset.czPhoto === want) || photos.find((img) => img.dataset.czPhoto === `shared|${state.shape}-${side}`);
  }
  function showLayer(side = state.side) {
    const photo = photoFor(side);
    photos.forEach((img) => { img.hidden = img !== photo; });
    if (photo && !photo.getAttribute('src')) photo.src = photo.dataset.src;
    mocks.forEach((m) => { m.hidden = !!photo || m.dataset.czMock !== `${state.shape}-${side}`; });
    garment.style.setProperty('--gc', state.hex);
    garment.classList.toggle('has-photo', !!photo);
    const hex = state.hex.replace('#', ''); const n = parseInt(hex.length === 3 ? hex.split('').map((c) => c + c).join('') : hex, 16);
    const lum = (0.299 * ((n >> 16) & 255) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255)) / 255;
    garment.classList.toggle('is-light', lum > .6);
    return photo;
  }

  /* Print quality of an uploaded design at its current size on the garment */
  function quality(side) {
    const d = design[side];
    if (!d.has || !SHOW_QUALITY) return null;
    if (d.vector) return { level: 'great', label: strings.quality_vector, title: strings.quality_vector };
    const [, , w] = printArea(side);
    const cm = (PRINT_CM[state.shape] || {})[side] || (side === 'back' ? 36 : 28);
    const r = model.printQuality(d.px, d.s, w, cm);
    return { level: r.level, label: strings['quality_' + r.level], title: `${L.digits(Math.round(r.dpi))} DPI · ${L.digits(Math.round(r.cm))} cm` };
  }
  // A preset label only travels with the order while the design still sits exactly there.
  const placeName = (d) => d.place && Math.abs(d.x - d.place.x) < .6 && Math.abs(d.y - d.place.y) < .6 && Math.abs(d.s - d.place.s) < .6 && Math.abs(d.r) < .5 ? d.place.name : '';

  /* Real size on the garment. The stage is square, so 1% of it is the same length on
     both axes; the print area's real width (Theme editor, cm) sets the scale. */
  function dimsOf(side) {
    const d = design[side], [cx, cy, w, h] = printArea(side);
    const k = ((PRINT_CM[state.shape] || {})[side] || (side === 'back' ? 36 : 28)) / w;
    const wcm = d.s * .66 * k;
    return { w: wcm, h: wcm / aspectOf(d), x: (d.x - (cx - w / 2)) * k, y: (d.y - (cy - h / 2)) * k };
  }
  const r1 = (n) => Math.round(n * 10) / 10;
  function paintDims(side) {
    const el = q('[data-cz-dims]');
    if (!el || side !== state.side) return;
    const d = design[side];
    el.hidden = !d.has;
    if (!d.has) return;
    const m = dimsOf(side), pn = placeName(d);
    el.textContent = '';
    const place = document.createElement('span'); place.className = 'cz__dims-place';
    place.textContent = pn ? (q(`[data-cz-place="${pn}"][data-side="${side}"]`)?.textContent.trim() || pn) : el.dataset.custom;
    el.append(place);
    [[el.dataset.w, m.w], [el.dataset.h, m.h], [el.dataset.x, m.x], [el.dataset.y, m.y]].forEach(([label, v]) => {
      const s = document.createElement('span'); s.append(`${label} `);
      const b = document.createElement('strong'); b.textContent = `${L.digits(r1(v))} ${el.dataset.cm}`;
      s.append(b); el.append(s);
    });
  }
  function paintDesign(side) {
    const d = design[side];
    clampPos(d, side);
    d.el.style.setProperty('--dx', d.x + '%'); d.el.style.setProperty('--dy', d.y + '%');
    d.el.style.setProperty('--ds', d.s); d.el.style.setProperty('--dr', d.r + 'deg');
    d.el.hidden = !(d.has && side === state.side);
    d.pos.value = `x:${Math.round(d.x)},y:${Math.round(d.y)},scale:${Math.round(d.s)},rotate:${Math.round(d.r)}`;
    d.pos.disabled = !d.has;
    paintDims(side);
    d.drop.hidden = d.has; d.row.hidden = !d.has;
    d.drop.setAttribute('aria-busy', String(!!d.loading));
    q(`[data-cz-upload="${side}"] [data-cz-upload-status]`).hidden = !d.loading;
    if (d.dot) d.dot.hidden = !d.has;
    const chip = q(`[data-cz-quality="${side}"]`);
    if (chip) {
      const qual = quality(side);
      chip.hidden = !qual;
      if (qual) { chip.dataset.level = qual.level; chip.textContent = qual.label; chip.title = qual.title; }
    }
  }

  function paint() {
    SIDES.forEach(paintDesign);
    const d = cur();
    garmentProp.value = state.label;
    methodProp.value = state.method;
    colorProp.value = state.color;
    const withDesign = SIDES.filter((s) => design[s].has);
    sidesProp.value = withDesign.length === 2 ? (strings.both || 'Front + Back') : withDesign.map(sideName).join('');
    if (scale) { scale.value = Math.round(d.s); if (scaleOut) scaleOut.value = L.digits(Math.round(d.s)) + (L.settings.locale === 'ar' ? '٪' : '%'); }
    if (rotate) { rotate.value = Math.round(d.r); if (rotateOut) rotateOut.value = L.digits(Math.round(d.r)) + '°'; }
    root.dataset.shape = state.shape; root.dataset.side = state.side;
    showLayer(); paintArea();
    empty.hidden = d.has;
    const stageQuality = q('[data-cz-quality-stage]');
    if (stageQuality) {
      const qual = quality(state.side);
      stageQuality.hidden = !qual;
      if (qual) { stageQuality.dataset.level = qual.level; stageQuality.textContent = qual.label; stageQuality.title = qual.title; }
    }
    const places = q('[data-cz-places]');
    if (places) {
      places.hidden = !d.has;
      const active = placeName(d);
      qa('[data-cz-place]').forEach((b) => { b.hidden = b.dataset.side !== state.side; const on = !!active && active === b.dataset.czPlace && b.dataset.side === state.side; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', String(on)); });
    }
    syncTextLabel();
    const stickyTotal = q('[data-cz-sticky-total]');
    if (stickyTotal && total) stickyTotal.textContent = total.textContent;
    if (emptyLabel) emptyLabel.textContent = (strings.uploadSide || 'Upload [side] design').replace('[side]', sideName(state.side));
    if (fineSide) fineSide.textContent = sideName(state.side);
    if (fine) fine.classList.toggle('is-disabled', !d.has);
    qtyField.value = state.qty;
    sizesProp.value = state.sizes.slice(0, state.qty).map((sz, i) => `${i + 1}:${sz}`).join(', ');
    paintPricing();
    paintBoard();
    paintQuote();
    paintBulk();
    const short = state.method === 'Embroidery' && state.qty < MIN_EMB;
    minNotice.hidden = state.method !== 'Embroidery';
    minNotice.classList.toggle('is-blocking', short);
    if (eta) eta.textContent = fees().eta || (state.method === 'Embroidery' ? (strings.etaEmbroidery || '') : (strings.etaPrint || ''));
    if (tools) tools.hidden = !d.has || !state.editing;
    if (hint) hint.textContent = d.has ? (state.editing ? strings.edit_hint : strings.browse_hint) : strings.hint;
    canvas.classList.toggle('is-editing', state.editing && d.has);
    editToggle.hidden = !d.has;
    editToggle.textContent = state.editing ? strings.finish_editing : strings.edit_design;
    editToggle.setAttribute('aria-pressed', String(state.editing));
    if (colorLabel) colorLabel.textContent = state.colorKey === 'custom' ? (customInput?.value.trim() || strings.customColor || '') : (q('[data-cz-color].is-active')?.getAttribute('aria-label') || state.color);
    if (wa) {
      const methodLabel = q('[data-cz-method].is-active strong')?.textContent || state.method;
      const txt = `${strings.wa || ''} ${state.label} · ${colorLabel.textContent} · ${methodLabel} · ${sidesProp.value || '-'} · ${L.digits(state.qty)} (${sizeSummary()})`;
      wa.href = wa.href.replace(/\?text=.*$/, '') + '?text=' + encodeURIComponent(txt.trim());
    }
  }

  /* ---- Sizes ---- */
  /* Up to 6 pieces: one size row per piece. From 7: a size matrix (count per size). */
  function stdDefs() { return Array.from(sizeTpl.content.querySelectorAll('label')).map((label) => ({ value: label.querySelector('input').value, text: label.querySelector('span')?.textContent || label.querySelector('input').value })); }
  function defaultSize() {
    const values = stdDefs().map((def) => def.value), open = values.filter((value) => pickVariant(value)?.id);
    return open[Math.min(1, open.length - 1)] || values[Math.min(1, values.length - 1)] || '';
  }
  /* 4.12 — each custom-size row (name, length, width, sleeve, details) is a size option of
     its own: a column in the matrix, priced on the base variant, with its own quantity. */
  function customDefs() {
    if (!bulkActive('size')) return [];
    return [...qa('[data-cz-measure="size"] .cz__measure-row')].map((row, i) => {
      const name = row.querySelector('[data-k="size"]')?.value.trim();
      return { value: 'custom:' + row.dataset.mid, text: name || `${sizesList.dataset.mxCustom || 'Custom'} ${i + 1}`, custom: true, row };
    });
  }
  function sizeDefs() { return [...stdDefs(), ...customDefs()]; }
  function sizeText(value) {
    const d = sizeDefs().find((x) => x.value === value);
    if (!d?.custom) return d?.text ?? value;
    const g = (k) => d.row.querySelector(`[data-k="${k}"]`)?.value.trim() || '';
    const parts = [['length', 'L'], ['width', 'W'], ['sleeve', 'Sleeve']].filter(([k]) => g(k)).map(([k, l]) => `${l} ${g(k)}cm`);
    if (g('details')) parts.push(g('details'));
    return `Custom – ${g('size') || d.text}${parts.length ? ' (' + parts.join(' · ') + ')' : ''}`;
  }
  function sizeSummary() {
    const picked = state.sizes.slice(0, state.qty);
    if (!matrixOn()) return picked.join(', ');
    return mixText();
    return sizeDefs().map((def) => [def.text, picked.filter((v) => v === def.value).length]).filter(([, n]) => n).map(([t, n]) => `${t}×${L.digits(n)}`).join(', ');
  }
  function syncQtyUi() {
    qtyInput.value = state.qty;
    L.numberInputs?.sync(qtyInput);
    qa('[data-cz-qty-set]').forEach((c) => c.classList.toggle('is-active', Number(c.dataset.czQtySet) === state.qty));
  }
  function renderSizes() {
    const known = new Set(sizeDefs().map((d) => d.value));
    if (state.sizes.some((s) => !known.has(s))) { const f = defaultSize(); state.sizes = state.sizes.map((s) => (known.has(s) ? s : f)); }
    if (matrixOn()) renderMatrix(); else renderRows();
  }
  /* ---- 4.11 colour × size matrix. Single source of truth: one entry per piece in
     state.sizes (its size) and state.pc (its colour). Every count and total is derived. ---- */
  function matrixOn() { return state.qty >= MATRIX_AT || (state.mx && state.qty > 1); }
  function pieceColor(i) { return (matrixOn() && state.pc[i]) || state.colorKey; }
  function colorKeys() {
    const keys = [...new Set(qa('[data-cz-color]').map((b) => b.dataset.czColor).filter((k) => k && k !== 'custom'))];
    if (state.colorKey === 'custom' || state.pc.includes('custom')) keys.push('custom');
    return keys;
  }
  function counts() {
    const m = {};
    state.sizes.slice(0, state.qty).forEach((s, i) => { const c = pieceColor(i); m[c] = m[c] || {}; m[c][s] = (m[c][s] || 0) + 1; });
    return m;
  }
  function mixText() {
    const m = counts(), defs = sizeDefs();
    return colorKeys().filter((c) => m[c]).map((c) => `${colorInfo(c).name}: ` + defs.filter((d) => m[c][d.value]).map((d) => `${d.text}×${m[c][d.value]}`).join(', ')).join(' | ');
  }
  const toInt = (v) => Math.max(0, Math.round(Number(String(v).replace(/[٠-٩]/g, (d) => '٠١٢٣٤٥٦٧٨٩'.indexOf(d)).replace(/\D/g, '')) || 0));
  let refocus = false;
  function setCell(color, size, n, keepFocus) {
    n = toInt(n);
    const pieces = state.sizes.slice(0, state.qty).map((s, i) => [pieceColor(i), s]).filter(([c, s]) => !(c === color && s === size));
    for (let k = 0; k < n && pieces.length < MAX_QTY; k++) pieces.push([color, size]);
    if (pieces.length) {
      const ck = colorKeys(), sv = sizeDefs().map((d) => d.value);
      pieces.sort((x, y) => ck.indexOf(x[0]) - ck.indexOf(y[0]) || sv.indexOf(x[1]) - sv.indexOf(y[1]));
      state.pc = pieces.map((p) => p[0]); state.sizes = pieces.map((p) => p[1]); state.qty = pieces.length; state.mx = true;
      syncQtyUi();
    }
    renderSizes(); paint();
    if (!keepFocus) return;
    const el = sizesList.querySelector(`[data-c="${CSS.escape(color)}"][data-s="${CSS.escape(size)}"]`);
    if (el) { refocus = true; el.focus({ preventScroll: true }); const e = el.value.length; try { el.setSelectionRange(e, e); } catch (_) {} refocus = false; }
  }
  function renderMatrix() {
    sizesList.classList.add('is-matrix');
    priceSignature = '';
    const ds = sizesList.dataset, defs = sizeDefs(), fallback = defaultSize();
    state.sizes = state.sizes.slice(0, state.qty);
    while (state.sizes.length < state.qty) state.sizes.push(fallback);
    state.pc = state.sizes.map((s, i) => state.pc[i] || state.colorKey);
    state.sizes = state.sizes.map((s, i) => (pickVariant(s, state.pc[i])?.id || !pickVariant(fallback, state.pc[i])?.id ? s : fallback));
    const keys = colorKeys(), m = counts();
    const el = (tag, cls, text) => { const e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; };
    const sumOf = (o) => Object.values(o || {}).reduce((x, y) => x + y, 0);
    const colSum = (v) => keys.reduce((x, c) => x + ((m[c] || {})[v] || 0), 0);
    const head = el('tr'); head.append(el('th', '', ds.mxColor || ''), ...defs.map((d) => el('th', '', d.text)), el('th', '', ds.mxTotal || ''));
    const thead = el('thead'); thead.append(head);
    const tbody = el('tbody');
    keys.forEach((c) => {
      const info = colorInfo(c), tr = el('tr'), th = el('th'), dot = el('span', 'cz__mxt-dot');
      dot.style.setProperty('--swatch', info.hex); th.append(dot, info.label); tr.append(th);
      defs.forEach((d) => {
        const n = (m[c] || {})[d.value] || 0, td = el('td'), inp = el('input', n ? 'has-n' : '');
        inp.type = 'text'; inp.inputMode = 'numeric'; inp.autocomplete = 'off'; inp.value = String(n);
        inp.dataset.c = c; inp.dataset.s = d.value;
        inp.disabled = !pickVariant(d.value, c)?.id;
        inp.setAttribute('aria-label', `${info.label} ${d.text}`);
        inp.addEventListener('focus', () => { if (!refocus) inp.select(); });
        inp.addEventListener('input', () => setCell(c, d.value, inp.value, true));
        td.append(inp); tr.append(td);
      });
      tr.append(el('td', 'cz__mxt-tot', L.digits(sumOf(m[c]))));
      tbody.append(tr);
    });
    const foot = el('tr'); foot.append(el('th', '', ds.mxTotal || ''), ...defs.map((d) => el('td', '', L.digits(colSum(d.value)))), el('td', 'cz__mxt-tot', L.digits(state.qty)));
    const tfoot = el('tfoot'); tfoot.append(foot);
    const table = el('table', 'cz__mxt'); table.append(thead, tbody, tfoot);
    const wrap = el('div', 'cz__mxt-wrap'); wrap.append(table);
    const combos = keys.reduce((x, c) => x + Object.values(m[c] || {}).filter(Boolean).length, 0);
    const sum = el('div', 'cz__mx-sum');
    [[ds.mxPieces, state.qty], [ds.mxColors, keys.filter((c) => sumOf(m[c])).length], [ds.mxSizes, defs.filter((d) => colSum(d.value)).length], [ds.mxCombos, combos]]
      .forEach(([l, v]) => { const s = el('span', '', (l || '') + ' '); s.append(el('strong', '', L.digits(v))); sum.append(s); });
    sizesList.replaceChildren(el('p', 'small cz__mx-hint', ds.mxHint || ''), wrap, sum);
  }
  function changeSize(value, delta) {
    const picked = state.sizes.slice(0, state.qty);
    if (delta > 0) { if (picked.length >= MAX_QTY) return; picked.push(value); }
    else { const i = picked.lastIndexOf(value); if (i < 0 || picked.length <= 1) return; picked.splice(i, 1); }
    state.sizes = picked; state.qty = picked.length;
    syncQtyUi(); renderSizes(); paint(); L.buzz?.();
  }
  function renderRows() {
    sizesList.classList.remove('is-matrix');
    sizesList.innerHTML = '';
    priceSignature = '';
    for (let i = 0; i < state.qty; i++) {
      const row = sizeTpl.content.firstElementChild.cloneNode(true);
      // Piece captions are shopper-facing: same numerals as the price under them.
      row.querySelector('.cz__size-n').textContent = (strings.piece || 'Piece [n]').replace('[n]', L.digits(i + 1));
      const inputs = row.querySelectorAll('input');
      inputs.forEach((inp) => { inp.name = `cz-size-${i}`; inp.checked = false; });
      row.querySelector('[role="radiogroup"]').setAttribute('aria-label', row.querySelector('.cz__size-n').textContent);
      const want = state.sizes[i];
      const match = want && Array.from(inputs).find((inp) => inp.value === want);
      const available = Array.from(inputs).filter((input) => pickVariant(input.value)?.id);
      const chosen = match || available[Math.min(1, available.length - 1)];
      if (chosen) { chosen.checked = true; state.sizes[i] = chosen.value; }
      else state.sizes[i] = want || '';
      row.addEventListener('change', (e) => { if (e.target.matches('input')) { state.sizes[i] = e.target.value; paint(); } });
      sizesList.appendChild(row);
    }
  }
  function setQty(n) {
    state.qty = Math.max(1, Math.min(MAX_QTY, Math.round(Number(n) || 1)));
    if (state.qty < MATRIX_AT) { state.mx = false; state.pc = []; }
    qtyInput.value = state.qty;
    L.numberInputs?.sync(qtyInput);
    qa('[data-cz-qty-set]').forEach((c) => c.classList.toggle('is-active', Number(c.dataset.czQtySet) === state.qty));
    renderSizes(); paint();
  }
  qa('[data-cz-qty-step]').forEach((b) => b.addEventListener('click', () => { setQty(state.qty + Number(b.dataset.czQtyStep)); L.buzz(); }));
  qa('[data-cz-qty-set]').forEach((b) => b.addEventListener('click', () => { setQty(b.dataset.czQtySet); L.buzz(); }));
  qtyInput.addEventListener('change', () => setQty(qtyInput.value));

  /* ---- Method ---- */
  qa('[data-cz-method]').forEach((b) => b.addEventListener('click', () => {
    qa('[data-cz-method]').forEach((x) => { x.classList.toggle('is-active', x === b); x.setAttribute('aria-pressed', String(x === b)); });
    state.method = b.dataset.czMethod;
    if (state.method === 'Embroidery' && state.qty < MIN_EMB) { minNotice.hidden = false; minNotice.classList.add('is-pulse'); setTimeout(() => minNotice.classList.remove('is-pulse'), 700); }
    paint(); L.buzz();
  }));

  /* ---- Side tabs ---- */
  function setSide(side, animate = true) {
    if (state.side === side) return;
    qa('[data-cz-side]').forEach((b) => { const on = b.dataset.czSide === side; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', String(on)); });
    state.side = side;
    state.editing = false;
    if (animate) { garment.classList.remove('is-flip'); void garment.offsetWidth; garment.classList.add('is-flip'); }
    paint();
    L.buzz();
  }
  qa('[data-cz-side]').forEach((btn) => btn.addEventListener('click', () => setSide(btn.dataset.czSide)));
  editToggle.addEventListener('click', () => { state.editing = !state.editing; paint(); });

  /* ---- Upload (per side) ---- */
  function showError(msg) { err.textContent = msg; err.hidden = !msg; }
  function setFile(side, file, extra = {}) {
    showError('');
    if (!file) return;
    const d = design[side];
    if (file.size > MAX) { showError(strings.fileTooBig); d.input.value = ''; return; }
    if (!/^image\/(png|jpe?g|svg\+xml|webp)$/.test(file.type)) { showError(strings.fileType); d.input.value = ''; return; }
    const url = URL.createObjectURL(file);
    const request = {}; d.request = request; d.loading = true; paint();
    const image = new Image();
    image.onload = () => {
      if (d.request !== request) { URL.revokeObjectURL(url); return; }
      if (d.url) URL.revokeObjectURL(d.url);
      d.url = url; d.img.src = url; d.loading = false;
      centerInArea(d, side); d.s = defaultScale(side); d.r = 0; d.has = true; d.file = file;
      d.px = image.naturalWidth || 0;
      d.vector = file.type === 'image/svg+xml' || !!extra.text;
      d.text = extra.text || null;
      d.place = null;
      state.editing = false;
      if (state.side !== side) setSide(side, false);
      const thumb = d.row.querySelector('[data-cz-thumb]'); if (thumb) thumb.src = url;
      d.row.querySelector('[data-cz-filename]').textContent = extra.text ? (strings.text_file || '[text]').replace('[text]', extra.text.value) : file.name;
      d.row.querySelector('[data-cz-filesize]').textContent = `${L.digits(Math.ceil(file.size / 1024))} ${strings.kilobytes}`;
      d.el.classList.remove('is-pop'); void d.el.offsetWidth; d.el.classList.add('is-pop');
      paint(); L.buzz();
    };
    image.onerror = () => {
      URL.revokeObjectURL(url);
      if (d.request !== request) return;
      d.loading = false; d.input.value = ''; showError(strings.file_invalid); paint();
    };
    image.src = url;
  }
  function clearFile(side) {
    const d = design[side];
    d.request = null; d.loading = false;
    if (d.url) URL.revokeObjectURL(d.url);
    d.url = null;
    d.input.value = ''; d.img.removeAttribute('src'); d.has = false; d.file = null; d.pos.value = '';
    d.text = null; d.place = null; d.vector = false; d.px = 0;
    state.editing = false;
    if (d.mock) d.mock.value = '';
    paint();
  }
  SIDES.forEach((side) => {
    const d = design[side];
    d.input.addEventListener('change', () => setFile(side, d.input.files[0]));
    ['dragenter', 'dragover'].forEach((ev) => d.drop.addEventListener(ev, (e) => { e.preventDefault(); d.drop.classList.add('is-over'); }));
    ['dragleave', 'drop'].forEach((ev) => d.drop.addEventListener(ev, (e) => { e.preventDefault(); d.drop.classList.remove('is-over'); }));
    d.drop.addEventListener('drop', (e) => { const f = e.dataTransfer.files[0]; if (f) { try { d.input.files = e.dataTransfer.files; } catch {} setFile(side, f); } });
    q(`[data-cz-remove="${side}"]`).addEventListener('click', () => clearFile(side));
    q(`[data-cz-edit="${side}"]`).addEventListener('click', () => { setSide(side); state.editing = true; paint(); canvas.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
  });
  empty.addEventListener('click', () => cur().input.click());
  canvas.addEventListener('dragover', (e) => { e.preventDefault(); canvas.classList.add('is-over'); });
  canvas.addEventListener('dragleave', () => canvas.classList.remove('is-over'));
  canvas.addEventListener('drop', (e) => { e.preventDefault(); canvas.classList.remove('is-over'); const f = e.dataTransfer.files[0]; if (f) { try { cur().input.files = e.dataTransfer.files; } catch {} setFile(state.side, f); } });

  /* ---- Gestures: drag to move, knobs to scale / rotate ---- */
  let gesture = null;
  const stageRect = () => garment.getBoundingClientRect();
  const angleTo = (e, r, d) => Math.atan2(e.clientY - (r.top + r.height * d.y / 100), e.clientX - (r.left + r.width * d.x / 100)) * 180 / Math.PI;
  const distTo = (e, r, d) => Math.hypot(e.clientX - (r.left + r.width * d.x / 100), e.clientY - (r.top + r.height * d.y / 100));
  const norm = (deg) => ((deg + 180) % 360 + 360) % 360 - 180;

  SIDES.forEach((side) => {
    const d = design[side]; const el = d.el;
    el.addEventListener('pointerdown', (e) => {
      if (!state.editing || root.dataset.preparing === 'true') return;
      if (e.button !== 0 && e.pointerType === 'mouse') return;
      const knob = e.target.closest('[data-cz-knob]');
      const r = stageRect();
      gesture = knob
        ? { kind: knob.dataset.czKnob, r, s0: d.s, r0: d.r, a0: angleTo(e, r, d), d0: distTo(e, r, d) }
        : { kind: 'move', r, ox: e.clientX, oy: e.clientY, sx: d.x, sy: d.y };
      el.classList.add('is-dragging'); el.setPointerCapture(e.pointerId); e.preventDefault();
    });
    el.addEventListener('pointermove', (e) => {
      if (!gesture || !state.editing) return;
      const g = gesture;
      if (g.kind === 'move') { d.x = g.sx + (e.clientX - g.ox) / g.r.width * 100; d.y = g.sy + (e.clientY - g.oy) / g.r.height * 100; }
      else if (g.kind === 'scale') d.s = Math.max(SCALE_MIN, Math.min(SCALE_MAX, g.s0 * (distTo(e, g.r, d) / Math.max(1, g.d0))));
      else if (g.kind === 'rotate') { let r = g.r0 + (angleTo(e, g.r, d) - g.a0); if (e.shiftKey) r = Math.round(r / 15) * 15; d.r = norm(r); }
      paint();
    });
    ['pointerup', 'pointercancel'].forEach((ev) => el.addEventListener(ev, () => { gesture = null; el.classList.remove('is-dragging'); }));
    el.addEventListener('keydown', (e) => {
      if (!state.editing || root.dataset.preparing === 'true') return;
      const step = e.shiftKey ? 5 : 1; let used = true;
      switch (e.key) {
        case 'ArrowLeft': d.x -= step; break;
        case 'ArrowRight': d.x += step; break;
        case 'ArrowUp': d.y -= step; break;
        case 'ArrowDown': d.y += step; break;
        case '+': case '=': d.s = Math.min(SCALE_MAX, d.s + step * 2); break;
        case '-': case '_': d.s = Math.max(SCALE_MIN, d.s - step * 2); break;
        case '[': d.r = norm(d.r - step * 3); break;
        case ']': d.r = norm(d.r + step * 3); break;
        case 'Delete': case 'Backspace': clearFile(side); break;
        default: used = false;
      }
      if (used) { e.preventDefault(); paint(); }
    });
  });
  scale && scale.addEventListener('input', () => { cur().s = Number(scale.value); paint(); });
  rotate && rotate.addEventListener('input', () => { cur().r = Number(rotate.value); paint(); });

  /* ---- Toolbar ---- */
  qa('[data-cz-tool]').forEach((b) => b.addEventListener('click', () => {
    const d = cur();
    switch (b.dataset.czTool) {
      case 'zoom-in': d.s = Math.min(SCALE_MAX, d.s + 4); break;
      case 'zoom-out': d.s = Math.max(SCALE_MIN, d.s - 4); break;
      case 'rotate-l': d.r = norm(d.r - 15); break;
      case 'rotate-r': d.r = norm(d.r + 15); break;
      case 'center': centerInArea(d); break;
      case 'reset': centerInArea(d); d.s = defaultScale(); d.r = 0; break;
      case 'fit': centerInArea(d); d.s = clampS(model.fitWidth(printArea(), .92, aspectOf(d)) / .66); d.r = 0; break;
      case 'replace': d.input.click(); return;
      case 'remove': clearFile(state.side); return;
    }
    paint(); L.buzz();
  }));

  /* ---- Placement presets ---- */
  qa('[data-cz-place]').forEach((b) => b.addEventListener('click', () => {
    const d = cur();
    if (!d.has) return;
    const p = model.placementFor(printArea(), state.side, b.dataset.czPlace, aspectOf(d));
    if (!p) return;
    d.x = p.x; d.y = p.y; d.s = Math.max(SCALE_MIN, Math.min(SCALE_MAX, p.s)); d.r = 0;
    clampPos(d, state.side);
    d.place = { name: b.dataset.czPlace, x: d.x, y: d.y, s: d.s };
    d.el.classList.remove('is-pop'); void d.el.offsetWidth; d.el.classList.add('is-pop');
    paint(); L.buzz();
  }));

  /* ---- Text designs: typed words become a transparent PNG for the side ---- */
  function trimCanvas(c, margin) {
    const { width, height } = c;
    const data = c.getContext('2d').getImageData(0, 0, width, height).data;
    let top = height, left = width, right = -1, bottom = -1;
    for (let y = 0; y < height; y++) {
      for (let x = 0; x < width; x++) {
        if (data[(y * width + x) * 4 + 3] > 8) { if (x < left) left = x; if (x > right) right = x; if (y < top) top = y; if (y > bottom) bottom = y; }
      }
    }
    if (right < 0) return c;
    left = Math.max(0, left - margin); top = Math.max(0, top - margin);
    right = Math.min(width - 1, right + margin); bottom = Math.min(height - 1, bottom + margin);
    const out = document.createElement('canvas');
    out.width = right - left + 1; out.height = bottom - top + 1;
    out.getContext('2d').drawImage(c, left, top, out.width, out.height, 0, 0, out.width, out.height);
    return out;
  }
  async function textToFile(value, role, color) {
    const css = getComputedStyle(document.documentElement);
    const pick = (name, fallback) => css.getPropertyValue(name).trim() || fallback;
    const display = pick('--font-display', 'sans-serif');
    const family = role === 'body' ? pick('--font-body', display) : role === 'accent' ? pick('--font-accent', display) : display;
    const weight = role === 'body' ? pick('--w-ui', '600') : role === 'accent' ? pick('--w-accent', '400') : pick('--w-heading', '800');
    const size = 240, spec = `${weight} ${size}px ${family}`;
    try { await document.fonts.load(spec, value); } catch {}
    const lines = value.split(/\r?\n/).map((line) => line.trim()).filter(Boolean).slice(0, 3);
    const rtl = /[\u0590-\u08FF]/.test(value);
    const probe = document.createElement('canvas').getContext('2d');
    probe.font = spec;
    const lineH = Math.round(size * 1.35), pad = Math.round(size * .35);
    const c = document.createElement('canvas');
    c.width = Math.min(4096, Math.ceil(Math.max(...lines.map((line) => probe.measureText(line).width))) + pad * 2);
    c.height = Math.min(4096, lineH * lines.length + pad * 2);
    const ctx = c.getContext('2d');
    ctx.font = spec; ctx.fillStyle = color; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    try { ctx.direction = rtl ? 'rtl' : 'ltr'; } catch {}
    lines.forEach((line, i) => ctx.fillText(line, c.width / 2, pad + lineH * (i + .5)));
    const out = trimCanvas(c, Math.round(size * .08));
    const blob = await new Promise((res) => out.toBlob(res, 'image/png'));
    if (!blob) throw new Error('text');
    return new File([blob], `text-${state.side}-${Date.now()}.png`, { type: 'image/png' });
  }
  const textBox = q('[data-cz-text]');
  const textApply = q('[data-cz-text-apply]');
  if (textBox && textApply) {
    const input = q('[data-cz-text-input]'), toggle = q('[data-cz-text-toggle]');
    let fontRole = 'display', color = textBox.querySelector('[data-cz-text-color].is-active')?.dataset.czTextColor || '#f4e8d8';
    syncTextLabel = () => { textApply.textContent = (strings.text_apply || '[side]').replace('[side]', sideName(state.side)); };
    toggle?.addEventListener('click', () => {
      const open = textBox.hidden;
      textBox.hidden = !open; toggle.setAttribute('aria-expanded', String(open));
      if (open) { syncTextLabel(); input.focus(); }
    });
    qa('[data-cz-text-font]').forEach((b) => b.addEventListener('click', () => {
      fontRole = b.dataset.czTextFont;
      qa('[data-cz-text-font]').forEach((x) => { const on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-checked', String(on)); });
    }));
    const pickColor = (hex, btn) => {
      color = hex;
      qa('[data-cz-text-color]').forEach((x) => { const on = x === btn; x.classList.toggle('is-active', on); x.setAttribute('aria-checked', String(on)); });
    };
    qa('[data-cz-text-color]').forEach((b) => b.addEventListener('click', () => pickColor(b.dataset.czTextColor, b)));
    q('[data-cz-text-custom]')?.addEventListener('input', (e) => pickColor(e.target.value, null));
    textApply.addEventListener('click', async () => {
      const value = input.value.trim();
      if (!value) { showError(strings.text_empty); input.focus(); return; }
      textApply.classList.add('is-loading');
      try {
        const file = await textToFile(value, fontRole, color);
        const fontLabel = q(`[data-cz-text-font="${fontRole}"]`)?.textContent.trim() || fontRole;
        setFile(state.side, file, { text: { value, font: fontLabel, color } });
        textBox.hidden = true; toggle?.setAttribute('aria-expanded', 'false');
      } catch { showError(strings.file_invalid); }
      textApply.classList.remove('is-loading');
    });
  }

  /* ---- Phones: total + add-to-bag follow the shopper once the stage is passed ---- */
  const sticky = q('[data-cz-sticky]'), submitButton = q('[data-cz-submit]');
  if (sticky && submitButton && 'IntersectionObserver' in window) {
    let pastStage = false, submitInView = false;
    const update = () => {
      const show = pastStage && !submitInView;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show));
      sticky.inert = !show;
    };
    new IntersectionObserver(([en]) => { submitInView = en.isIntersecting; update(); }).observe(submitButton);
    new IntersectionObserver(([en]) => { pastStage = !en.isIntersecting && en.boundingClientRect.top < 0; update(); }).observe(q('.cz__stage') || canvas);
    q('[data-cz-sticky-submit]')?.addEventListener('click', () => { if (form.requestSubmit) form.requestSubmit(submitButton); else submitButton.click(); });
  }

  /* ---- Mockup board: the current colour + designs on every piece ---- */
  function areaOf(shape, side) { return (AREA[shape] || {})[side] || [50, 45, 52, 52]; }
  function paintBoard() {
    if (!board) return;
    board.querySelectorAll('[data-cz-board-card]').forEach((card) => {
      const [shape, side] = card.dataset.czBoardCard.split('-');
      const photo = photos.find((img) => img.dataset.czPhoto === `${state.colorKey}|${shape}-${side}`) || photos.find((img) => img.dataset.czPhoto === `shared|${shape}-${side}`);
      const img = card.querySelector('[data-cz-board-photo]');
      if (photo && img.dataset.src !== photo.dataset.src) { img.dataset.src = photo.dataset.src; img.src = photo.dataset.src; }
      img.hidden = !photo;
      const d = design[side], art = card.querySelector('[data-cz-board-art]'), src = d.has && d.img?.getAttribute('src');
      art.hidden = !src;
      if (src) {
        const from = areaOf(state.shape, side), to = areaOf(shape, side), kx = to[2] / from[2], ky = to[3] / from[3];
        if (art.getAttribute('src') !== src) art.src = src;
        art.style.left = `${to[0] + (d.x - from[0]) * kx}%`;
        art.style.top = `${to[1] + (d.y - from[1]) * ky}%`;
        art.style.width = `${d.s * 0.66 * kx}%`;
        art.style.height = 'auto';
        art.style.transform = `translate(-50%, -50%) rotate(${d.r}deg)`;
      }
      card.classList.toggle('is-active', shape === state.shape && side === state.side);
    });
  }
  function paintQuote() {
    const link = q('[data-cz-quote]');
    if (!link) return;
    const parts = [strings.quote_msg, strings['seg_' + state.segment], orgInput?.value.trim(), state.label, colorLabel?.textContent, q('[data-cz-method].is-active strong')?.textContent || state.method, `${L.digits(state.qty)} (${sizeSummary()})`, state.quoteTotal ? L.money(state.quoteTotal) : ''];
    link.href = link.href.replace(/\?text=.*$/, '') + '?text=' + encodeURIComponent(parts.filter(Boolean).join(' · '));
  }
  function setSegment(seg) {
    state.segment = seg; tiers = tiersFor(seg); priceSignature = '';
    qa('[data-cz-seg]').forEach((b) => { const on = b.dataset.czSeg === seg; b.classList.toggle('is-active', on); b.setAttribute('aria-checked', String(on)); });
    const isOrg = seg !== 'individual';
    if (orgBox) orgBox.hidden = !isOrg;
    if (orgInput) orgInput.disabled = !isOrg;
    if (orgLabel) orgLabel.textContent = strings[`org_${seg}`] || strings.org_name || '';
    if (orgNote) orgNote.textContent = isOrg ? interpolate(strings[`seg_note_${seg}`], { count: L.digits(tiers[0]?.quantity || 10) }) : '';
    if (segProp) segProp.value = SEG_EN[seg] || seg;
    qa('[data-cz-chip-seg]').forEach((chip) => { chip.hidden = (chip.dataset.czChipSeg === 'org') !== isOrg; });
    paint();
  }

  /* ---- Garment / colour ---- */
  /* 5.2 — the size-guide drawer shows the guide of the selected garment only */
  const syncGuide = () => document.querySelectorAll('[data-guide-for]').forEach((el) => { el.hidden = el.dataset.guideFor !== state.shape; });
  syncGuide();
  qa('[data-cz-garment-opt]').forEach((btn) => btn.addEventListener('click', () => {
    if (!catalog[btn.dataset.czGarmentOpt]) return;
    qa('[data-cz-garment-opt]').forEach((b) => { b.classList.toggle('is-active', b === btn); b.setAttribute('aria-pressed', String(b === btn)); });
    state.shape = btn.dataset.czGarmentOpt; state.label = btn.dataset.label || state.shape;
    garment.classList.remove('is-swap'); void garment.offsetWidth; garment.classList.add('is-swap');
    SIDES.forEach((s) => { centerInArea(design[s], s); design[s].s = Math.min(design[s].s, fitScale(s)); });
    syncGuide(); paint(); L.buzz();
  }));
  qa('[data-cz-color]').forEach((btn) => btn.addEventListener('click', () => {
    qa('[data-cz-color]').forEach((b) => { b.classList.toggle('is-active', b === btn); b.setAttribute('aria-pressed', String(b === btn)); });
    state.colorKey = btn.dataset.czColor; state.color = btn.dataset.czColorName || ''; state.colorValue = btn.dataset.czVariantKey || state.color; state.hex = btn.dataset.czTone || '#181818';
    const custom = state.colorKey === 'custom';
    if (customBox) customBox.hidden = !custom;
    if (custom) { state.color = customName(); customInput?.focus({ preventScroll: true }); }
    if (matrixOn()) renderSizes();
    garment.classList.remove('is-swap'); void garment.offsetWidth; garment.classList.add('is-swap');
    paint(); L.buzz();
  }));

  /* ---- Mockups: one composited JPEG per side that has a design ---- */
  function loadImg(src) {
    return new Promise((resolve, reject) => {
      const image = new Image(); image.crossOrigin = 'anonymous';
      const timeout = setTimeout(() => reject(new Error(strings.mockup_failed)), 10000);
      image.onload = () => { clearTimeout(timeout); resolve(image); };
      image.onerror = () => { clearTimeout(timeout); reject(new Error(strings.mockup_failed)); };
      image.src = src;
    });
  }
  async function buildMockup(side) {
    const d = design[side];
    if (!d.has || !d.mock) return null;
    const photo = photoFor(side);
    const size = 1000;
    const c = document.createElement('canvas'); c.width = size; c.height = size;
    const ctx = c.getContext('2d');
    ctx.fillStyle = '#0b2a1c'; ctx.fillRect(0, 0, size, size);
    try {
      let base = null;
      if (photo) base = await loadImg(photo.dataset.src);
      else {
        const svg = mocks.find((m) => m.dataset.czMock === `${state.shape}-${side}`)?.querySelector('svg');
        if (svg) { const clone = svg.cloneNode(true); clone.querySelectorAll('[fill="var(--gc)"]').forEach((el) => el.setAttribute('fill', state.hex)); clone.setAttribute('width', size); clone.setAttribute('height', size); const u = URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(clone)], { type: 'image/svg+xml' })); base = await loadImg(u); URL.revokeObjectURL(u); }
      }
      if (!base) throw new Error(strings.mockup_failed);
      const fit = Math.min(size / base.naturalWidth, size / base.naturalHeight);
      const width = base.naturalWidth * fit, height = base.naturalHeight * fit;
      ctx.drawImage(base, (size - width) / 2, (size - height) / 2, width, height);
      const dw = size * d.s / 100 * .66;
      const dh = dw * (d.img.naturalHeight / Math.max(1, d.img.naturalWidth));
      ctx.save(); ctx.translate(size * d.x / 100, size * d.y / 100); ctx.rotate(d.r * Math.PI / 180);
      ctx.drawImage(d.img, -dw / 2, -dh / 2, dw, dh); ctx.restore();
      const blob = await new Promise((res) => c.toBlob(res, 'image/jpeg', .85));
      if (!blob) throw new Error(strings.mockup_failed);
      const file = new File([blob], `mockup-${state.shape}-${side}-${Date.now()}.jpg`, { type: 'image/jpeg' });
      return file;
    } catch { throw new Error(strings.mockup_failed); }
  }

  /* Group identical pieces so large orders do not upload the same artwork per piece. */
  let preparedItems = null, requestGroup = null, requestSignature = '';
  const lock = (busy) => {
    root.dataset.preparing = String(busy);
    root.setAttribute('aria-busy', String(busy));
    q('[data-cz-submit]').classList.toggle('is-loading', busy);
    if (busy) q('[data-cz-submit]').disabled = true;
  };
  for (const event of ['click', 'keydown', 'change', 'input', 'drop']) {
    root.addEventListener(event, (e) => {
      if (root.dataset.preparing !== 'true') return;
      e.preventDefault(); e.stopImmediatePropagation();
    }, true);
  }
  function flagMissing(el, msg) {
    L.toast?.(msg, { type: 'error', icon: 'info', duration: 4200 });
    if (!el) return;
    el.classList.remove('is-missing'); void el.offsetWidth; el.classList.add('is-missing');
    setTimeout(() => el.classList.remove('is-missing'), 2800);
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const f = el.matches('input, button, textarea, select') ? el : el.querySelector('input:not([type="hidden"]):not([disabled]), button:not([disabled])');
    setTimeout(() => f?.focus({ preventScroll: true }), 450);
  }
  form.getCartItems = () => {
    if (!preparedItems) throw new Error(strings.selection_unavailable);
    return preparedItems;
  };
  form.onCartAddSuccess = () => { requestGroup = null; requestSignature = ''; };
  form.refreshProduct = () => { preparedItems = null; lock(false); paint(); };
  form.addEventListener('submit', (e) => {
    if (preparedItems) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (root.dataset.preparing === 'true') return;
    let msg = '';
    const any = SIDES.some((s) => design[s].has);
    const groups = model.groupPieces(selectedVariants(), state.sizes.slice(0, state.qty), state.sizes.slice(0, state.qty).map((s, i) => pieceColor(i)));
    if (!any) msg = strings.needDesign;
    else if (state.colorKey === 'custom' && !customInput?.value.trim()) msg = strings.customColorNeeded;
    else if (state.method === 'Embroidery' && state.qty < MIN_EMB) msg = strings.minEmbroidery;
    else if (bulkError()) msg = bulkError();
    else if (!groups) msg = strings.selection_unavailable;
    else if (SIDES.some((side) => design[side].loading)) return;
    if (msg) { const target = msg === strings.customColorNeeded ? customInput : msg === strings.minEmbroidery ? (q('[data-cz-method].is-active') || sizesList) : !any ? (q('[data-cz-upload]') || canvas) : sizesList; submitErr.textContent = msg; submitErr.hidden = false; flagMissing(target, msg); return; }
    submitErr.hidden = true;
    const signature = JSON.stringify([state.shape, state.color, state.method, state.qty, state.sizes.slice(0, state.qty), state.pc.slice(0, state.qty), q('[data-cz-notes]').value, SIDES.map((side) => [design[side].url, design[side].pos.value])]);
    if (!requestGroup || signature !== requestSignature) { requestGroup = crypto.randomUUID(); requestSignature = signature; }
    lock(true);
    const properties = { Garment: state.shape === 'tee' ? 'T-shirt' : 'Hoodie', Colour: state.color, Method: state.method, Sides: SIDES.filter((side) => design[side].has).map((side) => side === 'front' ? 'Front' : 'Back').join(' + '), Notes: q('[data-cz-notes]').value, _customize_group: requestGroup };
    if (orgInput && !orgInput.disabled && orgInput.value.trim()) properties.Organization = orgInput.value.trim();
    Object.assign(properties, bulkProps());
    Promise.all(SIDES.map(buildMockup)).then((files) => {
      SIDES.forEach((side, index) => {
        const d = design[side], label = side === 'front' ? 'Front' : 'Back';
        if (!d.has) return;
        properties[`${label} design`] = d.file;
        properties[`${label} mockup`] = files[index];
        properties[`${label} position`] = d.pos.value;
        const m = dimsOf(side);
        properties[`${label} size (cm)`] = `${r1(m.w)} × ${r1(m.h)} cm (W × H)`;
        properties[`${label} X / Y (cm)`] = `${r1(m.x)} / ${r1(m.y)} cm, design centre from the print area's top-left`;
        if (!placeName(d)) properties[`${label} placement`] = 'Custom position';
        if (d.text) properties[`${label} text`] = `${d.text.value} · ${d.text.font} · ${d.text.color}`;
        const place = placeName(d);
        if (place) properties[`${label} placement`] = PLACE_EN[place] || (side === 'front' ? 'Full front' : 'Full back');
      });
      if (matrixOn()) properties.Breakdown = mixText();
      preparedItems = groups.map((group) => ({ id: group.id, quantity: group.quantity, properties: { ...properties, Colour: colorInfo(group.tag || state.colorKey).name || properties.Colour, Size: sizeText(group.size), Piece: group.pieces.join(', ') } }));
      const ex = extras(), fv = fees().variant;
      if (fv && ex.total > 0) preparedItems.push({ id: fv, quantity: ex.total, properties: { For: `${properties.Garment} × ${state.qty}`, Extras: ex.lines.map(([n, v, c]) => `${n} ${v} EGP × ${c}`).join(', ') } });
      q('[data-cz-submit]').disabled = false;
      form.requestSubmit();
    }).catch((error) => {
      preparedItems = null; lock(false); paint();
      submitErr.textContent = error.message || strings.mockup_failed; submitErr.hidden = false;
    });
  }, true);

  L.on('cart:updated', (cart) => {
    for (const product of Object.values(catalog)) {
      for (const variant of product?.variants || []) variant.cart_quantity = (cart.items || []).filter((item) => Number(item.variant_id) === Number(variant.id)).reduce((count, item) => count + item.quantity, 0);
    }
    priceSignature = ''; paint();
  });

  qa('[data-cz-seg]').forEach((b) => b.addEventListener('click', () => { setSegment(b.dataset.czSeg); L.buzz?.(); }));
  qa('[data-cz-seg-from]').forEach((el) => {
    const best = tiersFor(el.dataset.czSegFrom).at(-1);
    el.textContent = best ? interpolate(strings.seg_save, { percent: L.digits(best.discount) }) : '';
  });
  customInput?.addEventListener('input', () => { if (state.colorKey === 'custom') { state.color = customName(); paint(); } });
  qa('[data-cz-board-card]').forEach((card) => card.addEventListener('click', () => {
    const [shape, side] = card.dataset.czBoardCard.split('-');
    if (!catalog[shape]) return;
    if (state.shape !== shape) q(`[data-cz-garment-opt="${shape}"]`)?.click();
    setSide(side);
    paint();
    q('.cz__stage')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }));

  /* ---- 4.7 bulk options: locked until a minimum quantity ---- */
  function fees() { return root._czFees || (root._czFees = JSON.parse(q('[data-cz-fees]')?.textContent || '{}')); }
  function bulkActive(k) { const b = q(`[data-cz-bulk-opt="${k}"]`); return !!b && !!(state.bulkOn || {})[k] && state.qty >= Number(b.dataset.czMin || 0); }
  function extras() {
    const f = fees(), lines = [], n = state.qty;
    const norm = (v) => String(v || '').toUpperCase().replace(/\s/g, '').replace(/^XXXL$/, '3XL').replace(/^XXL$/, '2XL');
    const add = (name, per, count = n) => { if (Number(per) && count) lines.push([name, Number(per), count]); };
    if (design.front.has && design.back.has) add('Both sides', f.sides);
    { const nc = state.sizes.slice(0, n).filter((s, i) => pieceColor(i) === 'custom').length; if (nc) add('Custom colour', f.color, nc); }
    if (state.method === 'Embroidery') add('Embroidery', f.emb);
    if (state.shape === 'tee') add('T-shirt', f.tee);
    if (bulkActive('size')) add('Custom size', f.size, state.sizes.slice(0, n).filter((v) => String(v).startsWith('custom:')).length);
    if (bulkActive('cut')) add('Custom cut', f.cut);
    const big = (f.bigSizes || []).map(norm).filter(Boolean);
    if (big.length) add('Big sizes', f.big, state.sizes.slice(0, n).filter((v) => big.includes(norm(v))).length);
    return { lines, total: Math.round(lines.reduce((sum, [, v, c]) => sum + v * c, 0)) };
  }
  function measureRows(k) {
    return Array.from(root.querySelectorAll(`[data-cz-measure="${k}"] .cz__measure-row`)).map((row) => {
      const v = (key) => row.querySelector(`[data-k="${key}"]`)?.value.trim() || '';
      const parts = [['length', 'L'], ['width', 'W'], ['sleeve', 'Sleeve']].filter(([key]) => v(key)).map(([key, lbl]) => `${lbl} ${v(key)}cm`);
      if (v('details')) parts.push(v('details'));
      return v('size') || parts.length ? `${v('size') || '?'}${parts.length ? ': ' + parts.join(' · ') : ''}` : '';
    }).filter(Boolean);
  }
  function bulkError() {
    const cmin = Number(q('[data-cz-color="custom"]')?.dataset.czMin || 0);
    if (state.colorKey === 'custom' && state.qty < cmin) return interpolate(strings.locked_toast, { count: L.digits(cmin) });
    if (bulkActive('size')) {
      const cds = customDefs(), picked = state.sizes.slice(0, state.qty), used = cds.filter((d) => picked.includes(d.value));
      if (!used.length) return sizesList.dataset.mxCustomQty || strings.size_needed;
      const bad = used.find((d) => !['length', 'width'].every((k) => d.row.querySelector(`[data-k="${k}"]`)?.value.trim()));
      if (bad) { bad.row.classList.add('is-error'); bad.row.querySelector('[data-k="length"]')?.focus(); return strings.size_needed; }
    }
    if (bulkActive('cut') && !q('[data-cz-cut-name]')?.value.trim() && !q('[data-cz-cut-photo]')?.files?.length) return strings.cut_needed;
    return '';
  }
  function bulkProps() {
    const p = {};
    if (bulkActive('size')) p['Custom sizes'] = measureRows('size').join(' | ');
    if (bulkActive('cut')) {
      p['Custom cut'] = q('[data-cz-cut-name]').value.trim();
      Array.from(q('[data-cz-cut-photo]')?.files || []).slice(0, 6).forEach((file, i) => { p[`Cut photo ${i + 1}`] = file; });
      const rows = measureRows('cut'); if (rows.length) p['Cut sizes'] = rows.join(' | ');
    }
    const ex = extras(); if (ex.total) p.Extras = ex.lines.map(([n, v, c]) => `${n} +${v} EGP × ${c}`).join(', ');
    return p;
  }
  function paintBulk() {
    if (state.method === 'Embroidery' && state.qty < MIN_EMB) { q('[data-cz-method="Print"]')?.click(); return; }
    qa('[data-cz-min]').forEach((el) => el.classList.toggle('is-locked', state.qty < Number(el.dataset.czMin || 0)));
    qa('[data-cz-lock-for]').forEach((el) => { el.hidden = state.qty >= Number(el.dataset.czLockFor || 0); });
    qa('[data-cz-bulk-opt]').forEach((b) => {
      const k = b.dataset.czBulkOpt, on = bulkActive(k);
      b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', String(on));
      const panel = q(`[data-cz-bulk-panel="${k}"]`); if (panel) panel.hidden = !on;
    });
  }
  let measureSeq = 0;
  function addMeasure(k) {
    const row = q('[data-cz-measure-row]').content.firstElementChild.cloneNode(true);
    row.dataset.mid = String(++measureSeq);
    row.querySelector('.cz__measure-x').addEventListener('click', () => { row.remove(); if (k === 'size') onCustomInput(); });
    q(`[data-cz-measure="${k}"]`).append(row);
    return row;
  }
  function setSizeCount(value, n) {
    const k = Math.max(0, Math.round(Number(n) || 0)), others = state.sizes.slice(0, state.qty).filter((v) => v !== value);
    if (others.length + k >= 1) { state.sizes = [...others, ...Array(k).fill(value)]; state.qty = state.sizes.length; }
    syncQtyUi(); renderSizes(); paint();
  }
  // Locked choices stay visible; tapping one below its minimum explains why.
  root.addEventListener('click', (e) => {
    const el = e.target.closest('[data-cz-min]');
    if (!el || state.qty >= Number(el.dataset.czMin || 0)) return;
    e.preventDefault(); e.stopImmediatePropagation();
    L.toast(interpolate(strings.locked_toast, { count: L.digits(el.dataset.czMin) }), { type: 'error', icon: 'info', duration: 4200 });
    L.buzz?.();
  }, true);
  qa('[data-cz-bulk-opt]').forEach((b) => b.addEventListener('click', () => {
    const k = b.dataset.czBulkOpt; state.bulkOn = state.bulkOn || {}; state.bulkOn[k] = !state.bulkOn[k];
    if (state.bulkOn[k] && !q(`[data-cz-measure="${k}"]`)?.children.length) addMeasure(k);
    priceSignature = ''; renderSizes(); paint(); L.buzz?.();
  }));
  qa('[data-cz-measure-add]').forEach((b) => b.addEventListener('click', () => addMeasure(b.dataset.czMeasureAdd).querySelector('input')?.focus()));
  q('[data-cz-cut-name]')?.addEventListener('input', () => { priceSignature = ''; });
  function onCustomInput() { priceSignature = ''; qa('.cz__measure-row.is-error').forEach((r) => r.classList.remove('is-error')); if (matrixOn()) renderSizes(); paint(); }
  q('[data-cz-measure="size"]')?.addEventListener('input', L.debounce ? L.debounce(onCustomInput, 250) : onCustomInput);

  renderSizes();
  SIDES.forEach((s) => centerInArea(design[s], s));
  paint();
})();
